import { structureContainerIds } from '@Pages/StructureEditor/StructureEditorConstants';

// Addition to /search/examples response, rendered as placeholder in quick search prompt input
export const QUICK_SEARCH_ADDITIONAL_EXAMPLES = [
  {
    prefix: '',
    suffix: 'applications of gold(I) catalysts in activation of alkynes for cyclization reactions',
  },
];

export const QUICK_SEARCH_TEXTS = {
  synthesisPlannerInfoDialogTitle: 'Synthesis Planner',
  synthesisPlannerInfoDialogText:
    'Please enter a structure ' +
    'or reaction query to find substances or reactions.<br />' +
    'On the result page hover your mouse over the structure you want ' +
    'to start a synthesis plan with and click "Synthesize".',
  synthesisPlannerInfoDialogButton: 'Ok',
};
export const QUICK_SEARCH_STRUCTURE_UID = structureContainerIds.quickSearch;

export const QUICK_SEARCH_CACHE_NAME = 'quickSearchCache';

export const SPINNER_ID = 'quick-search-spinner';

export const QUICK_SEARCH_CACHE_FORMS = {
  Reaxys: [
    {
      title: 'Substances',
      icon: '#icon-qs-substances',
    },
    {
      title: 'Reactions',
      icon: '#icon-qs-reactions',
    },
    {
      title: 'Natural Products',
      icon: '#icon-qs-natural-products',
    },
    {
      title: 'Patents',
      icon: '#icon-qs-patents',
    },
    {
      title: 'Bibliography',
      icon: '#icon-qs-bibliography',
    },
  ],
  ReaxysMedChem: [
    {
      title: 'Substances',
      icon: '#icon-qs-substances',
    },
    {
      title: 'Bioactivity',
      icon: '#icon-qs-bioactivity',
    },
    {
      title: 'Patents',
      icon: '#icon-qs-patents',
    },
    {
      title: 'Bibliography',
      icon: '#icon-qs-bibliography',
    },
  ],
  Both: [
    {
      title: 'Substances',
      icon: '#icon-qs-substances',
    },
    {
      title: 'Reactions',
      icon: '#icon-qs-reactions',
    },
    {
      title: 'Bioactivity',
      icon: '#icon-qs-bioactivity',
    },
    {
      title: 'Natural Products',
      icon: '#icon-qs-natural-products',
    },
    {
      title: 'Patents',
      icon: '#icon-qs-patents',
    },
    {
      title: 'Bibliography',
      icon: '#icon-qs-bibliography',
    },
  ],
};
